// SPDX-License-Identifier: AGPL-3.0-or-later
import { en } from "./messages/en.js";
import { fr } from "./messages/fr.js";
import { APP_NAME } from "./brand.js";
export * from "./format.js";
export { APP_NAME } from "./brand.js";
export const catalogs = { "en-CA": en, "fr-CA": fr };
/**
 * Looks up a message and fills {placeholders}; {app} is the product name
 * unless the caller passes one. Falls back to English so a
 * missing translation never shows a raw key; the test suite fails the build
 * when any French string is missing.
 */
export function translate(locale, key, params = {}) {
    const template = catalogs[locale][key] ?? en[key] ?? key;
    const values = { app: APP_NAME, ...params };
    return template.replace(/\{(\w+)\}/g, (_, name) => String(values[name] ?? `{${name}}`));
}
//# sourceMappingURL=index.js.map